/** Tiempo real — contracts.md §4 (Socket.IO, path `/realtime`). */
import { z } from "zod";
import { ACCESS_REASONS, ACCESS_RESULTS } from "../enums.js";
import { accessPersonCard } from "./acceso.js";
import { moneySchema, objectId } from "./base.js";
export const REALTIME_PATH = "/realtime";
/** Rooms del contrato §4. */
export const room = {
    branch: (id) => `branch:${id}`,
    location: (id) => `location:${id}`,
    accessPoint: (id) => `accessPoint:${id}`,
    kiosk: (deviceId) => `kiosk:${deviceId}`,
    session: (classSessionId) => `session:${classSessionId}`,
    /** El socio/visitante conectado desde la app (RN-CRM-17: la respuesta llega en vivo). */
    person: (personId) => `person:${personId}`,
};
export const REALTIME_EVENTS = [
    "access.read",
    "cash.movement",
    "class.booking",
    "class.checkin",
    "kiosk.signRequest",
    "kiosk.signed",
    "waitlist.offer",
    "message.new",
];
/**
 * Cada lectura del molinete o del QR, tal como la pinta el semáforo de recepción
 * (AF §6, pantalla «Semáforo de ingreso»): nombre, número, DNI, iniciales/foto, badges,
 * el motivo en texto grande y los últimos ingresos del punto de acceso.
 */
export const accessReadEvent = z.object({
    accessLogId: objectId.nullable().default(null),
    accessPointId: objectId,
    locationId: objectId,
    branchId: objectId,
    result: z.enum(ACCESS_RESULTS),
    reason: z.string().nullable(),
    reasonCode: z.enum(ACCESS_REASONS).nullable().default(null),
    method: z.string().default("member_qr"),
    person: accessPersonCard.nullable(),
    /** RN-ACC-14: si el ingreso salió por excepción, quién la autorizó y por qué. */
    exception: z
        .object({ authorizedByUserId: objectId.nullable(), reason: z.string() })
        .nullable()
        .default(null),
    /** Los últimos ingresos del punto de acceso, para la lista de la pantalla. */
    recent: z
        .array(z.object({
        accessLogId: objectId,
        name: z.string(),
        result: z.enum(ACCESS_RESULTS),
        reason: z.string().nullable(),
        ts: z.coerce.date(),
    }))
        .default([]),
    ts: z.coerce.date(),
});
export const cashMovementEvent = z.object({
    shiftId: objectId,
    branchId: objectId,
    kind: z.string(),
    amount: moneySchema,
    ts: z.coerce.date(),
});
export const classBookingEvent = z.object({
    sessionId: objectId,
    bookingId: objectId,
    status: z.string(),
    occupied: z.number().int(),
    capacity: z.number().int(),
});
export const classCheckinEvent = z.object({
    sessionId: objectId,
    bookingId: objectId,
    personName: z.string(),
    at: z.coerce.date(),
});
export const kioskSignRequestEvent = z.object({
    deviceId: objectId,
    docVersionId: objectId,
    personName: z.string(),
    requestId: z.string(),
});
export const kioskSignedEvent = z.object({
    requestId: z.string(),
    signedDocumentId: objectId,
});
export const waitlistOfferEvent = z.object({
    sessionId: objectId,
    waitlistEntryId: objectId,
    personId: objectId,
    windowEndsAt: z.coerce.date(),
    simultaneous: z.boolean(),
});
/** RN-CRM-15/17: un mensaje nuevo en una conversación socio↔sede. */
export const messageNewEvent = z.object({
    conversationId: objectId,
    branchId: objectId,
    personId: objectId,
    from: z.enum(["person", "staff", "system"]),
    ts: z.coerce.date(),
});
//# sourceMappingURL=realtime.js.map